module.exports = __webpack_public_path__ + "img/Ellipse.jpg";